<ng-container *ngIf="orderData?.entries?.length > 0">
  <div class="order-review-component order-confirmation-shipto">
    <app-checkout-ship-to-rdd
      [shipToObj]="shiptoObj"
      [isOrderPlaced]="true"
      [orderData]="orderData"
      [isOrderDetails]="true"
    ></app-checkout-ship-to-rdd>
  </div>
  <div class="orderconfirmation-body-component d-flex">
    <app-checkout-order-list
      [cartData]="orderData"
      [isOrderConfirmation]="true"
    ></app-checkout-order-list>
    <app-checkout-order-summary
      [cartData]="orderData"
      [isOrderConfirmation]="true"
      [isOrderDetails]="true"
    ></app-checkout-order-summary>
  </div>
</ng-container>
